import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/Home'
import Login from '@/components/line/Login'
import TelVerification from '@/components/line/TelVerification'
import Register from '@/components/line/Register'
import FinishRegister from '@/components/line/FinishRegister'
import MemberCard from '@/components/line/MemberCard'
import MemberInfo from '@/components/line/MemberInfo'
import OrderSearch from '@/components/pages/OrderSearch'
import RegistrationList from '@/components/line/RegistrationList'
import EstimateList from '@/components/line/EstimateList'
import EstimateDetail from '@/components/line/EstimateDetail'
import HiQuiz from '@/components/pages/HiQuiz'
import PayHome from '@/components/pages/PayHome'
import PaySuccess from '@/components/Pay/PaySuccess'
import PayFail from '@/components/Pay/PayFail'
import PayPage from '@/components/Pay/PayPage'
import StoresList from '@/components/line/StoresList'
import StoresDetail from '@/components/line/StoresDetail'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/Login',
            name: 'Login',
            component: Login
        },
        {
            path: '/TelVerification',
            name: 'TelVerification',
            component: TelVerification
        },
        {
            path: '/Register',
            name: 'Register',
            component: Register
        },
        {
            path: '/FinishRegister',
            name: 'FinishRegister',
            component: FinishRegister
        },
        {
            path: '/MemberCard',
            name: 'MemberCard',
            component: MemberCard
        },
        {
            path: '/MemberInfo',
            name: 'MemberInfo',
            component: MemberInfo
        },
        {
            path: '/OrderSearch',
            name: 'OrderSearch',
            component: OrderSearch
        },
        {
            path: '/RegistrationList',
            name: 'RegistrationList',
            component: RegistrationList
        },
        {
            path: '/EstimateList',
            name: 'EstimateList',
            component: EstimateList
        },
        {
            path: '/EstimateDetail',
            name: 'EstimateDetail',
            component: EstimateDetail
        },
        {
            path: '/HiQuiz',
            name: 'HiQuiz',
            component: HiQuiz
        },
        {
            path: '/GoPay',
            name: 'PayHome',
            component: PayHome
        },
        {
            path: '/PayFail',
            name: 'PayFail',
            component: PayFail
        },
        {
            path: '/PaySuccess',
            name: 'PaySuccess',
            component: PaySuccess
        },
        {
            path: '/PayPage',
            name: 'PayPage',
            component: PayPage
        },
        {
            path: '/StoresList',
            name: 'StoresList',
            component: StoresList
        },
        {
            path: '/StoresDetail',
            name: 'StoresDetail',
            component: StoresDetail
        },

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js